import { supabase } from "../supabase/client";
import { isCloudChildId } from "../economy/starWallet";

export interface ParentAttempt {
  taskId: string;
  status: string;
  stars: number;
  startedAt: string;
  completedAt: string | null;
}

export interface ParentEvent {
  eventType: string;
  occurredAt: string;
  payload: Record<string, unknown>;
}

export interface ParentObservationData {
  attempts: ParentAttempt[];
  events: ParentEvent[];
  source: "cloud" | "local";
}

function localObservation(): ParentObservationData {
  let history: Array<{ taskId?: string; id?: string; stars?: number; completedAt?: string }> = [];
  let events: Array<{ event_type?: string; occurred_at?: string; payload?: Record<string, unknown> }> = [];
  try { history = JSON.parse(localStorage.getItem("lusky:task-history") || "[]"); } catch { history = []; }
  try { events = JSON.parse(localStorage.getItem("lusky:explore-event-queue:v1") || "[]"); } catch { events = []; }
  return {
    source: "local",
    attempts: history.map((item, index) => ({
      taskId: item.taskId || item.id || `local-${index}`,
      status: "completed",
      stars: Number(item.stars) || 0,
      startedAt: item.completedAt || new Date().toISOString(),
      completedAt: item.completedAt || null
    })),
    events: events.map((item) => ({
      eventType: item.event_type || "learning.activity",
      occurredAt: item.occurred_at || new Date().toISOString(),
      payload: item.payload || {}
    }))
  };
}

export async function loadParentObservation(childId: string | null): Promise<ParentObservationData> {
  const local = localObservation();
  if (!supabase || !isCloudChildId(childId)) return local;
  try {
    const query = Promise.all([
      supabase.from("task_attempts").select("task_id,status,stars,started_at,completed_at").eq("child_id", childId).order("started_at", { ascending: false }).limit(80),
      supabase.from("learning_events").select("event_type,payload,occurred_at").eq("child_id", childId).order("occurred_at", { ascending: false }).limit(160)
    ]);
    const timeout = new Promise<never>((_, reject) => window.setTimeout(() => reject(new Error("parent observation timeout")), 6000));
    const [attemptResult, eventResult] = await Promise.race([query, timeout]);
    if (attemptResult.error || eventResult.error) return local;
    return {
      source: "cloud",
      attempts: (attemptResult.data || []).map((item) => ({ taskId: item.task_id, status: item.status, stars: item.stars, startedAt: item.started_at, completedAt: item.completed_at })),
      events: (eventResult.data || []).map((item) => ({ eventType: item.event_type, occurredAt: item.occurred_at, payload: (item.payload || {}) as Record<string, unknown> }))
    };
  } catch { return local; }
}
